"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import makeStyles from "../../theming/make-styles.js";
import { ListContext } from "./list.js";
const useStyles = makeStyles()((theme, { color, empty }, classes) => {
    const palette = theme.palette(color).list;
    return {
        group: {
            [`&:first-child .${classes.label}`]: {
                borderBottomWidth: empty ? 0 : undefined,
            },
        },
        label: Object.assign(Object.assign({}, theme.typography.label), { position: "sticky", top: 0, padding: empty ? 0 : theme.spacing("sm", "md"), textAlign: "left", textTransform: "uppercase", color: palette.group.color, backgroundColor: palette.group.backgroundColor, borderBottom: `${theme.size(1)} solid ${palette.group.borderColor}` }),
    };
});
export const ListGroup = React.forwardRef(function ListGroup(_a, ref) {
    var { children, className, label } = _a, props = __rest(_a, ["children", "className", "label"]);
    const context = useContext(ListContext);
    const { classes, cx } = useStyles({ color: context.color, empty: !label });
    return (_jsxs("div", Object.assign({ ref: ref, className: cx(classes.group, className), "data-component": "list-group", role: "group" }, props, { children: [_jsx("div", { className: classes.label, children: label }), children] })));
});
export default ListGroup;
//# sourceMappingURL=list-group.js.map